import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoUpwork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 115 48'
    {...props}
  >
    <g fill='#14A800' clipPath='url(#Logo_Upwork_svg__a)'>
      <path d='M31.905 31.083c-3.183 0-5.29-2.411-5.878-3.345.754-5.91 2.961-7.778 5.878-7.778 2.884 0 5.125 2.26 5.125 5.562s-2.24 5.561-5.125 5.561m0-14.751c-5.19 0-8.097 3.313-8.929 6.724-.942-1.738-1.641-4.063-2.185-6.224h-7.176v8.744c0 3.172-1.476 5.518-4.36 5.518-2.883 0-4.536-2.346-4.536-5.518l.033-8.744H.615v8.744c0 2.553.843 4.866 2.385 6.517C4.586 33.8 6.749 34.69 9.256 34.69c4.991 0 8.474-3.748 8.474-9.114v-5.877c.521 1.934 1.764 5.649 4.137 8.908L19.65 40.979h4.204l1.464-8.766c.477.391.987.739 1.53 1.054a9.5 9.5 0 0 0 4.681 1.412s.255.01.389.01c5.146 0 9.239-3.899 9.239-9.167 0-5.269-4.104-9.19-9.25-9.19M91.347 18.701v-1.868h-4.06v17.304h4.116v-6.778c0-4.171.388-7.17 6.1-6.778v-3.954c-2.662-.196-4.736.347-6.156 2.074M62.776 16.834l-2.984 12.1-3.184-12.1h-5.235l-3.194 12.1-2.973-12.1h-4.17l4.57 17.315h4.946l3.439-12.297 3.405 12.297h4.947l4.836-17.315zM76.241 31.094c-2.928 0-5.124-2.26-5.124-5.572s2.207-5.562 5.124-5.562c2.884 0 5.125 2.26 5.125 5.562s-2.24 5.572-5.125 5.572m0-14.762c-5.18 0-9.24 3.932-9.24 9.19s4.06 9.157 9.24 9.157c5.147 0 9.24-3.9 9.24-9.157 0-5.258-4.082-9.19-9.24-9.19M103.405 25.631h.954l5.746 8.516h4.647l-6.611-9.44c3.206-1.227 5.358-4.431 5.358-7.875h-4.104c0 3.737-3.006 5.15-5.99 5.15V10h-4.126v24.147h4.115z' />
    </g>
    <defs>
      <clipPath id='Logo_Upwork_svg__a'>
        <path fill='#fff' d='M.615 0h114v48h-114z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoUpwork;
